import { render, staticRenderFns } from "./NotificationEditor.vue?vue&type=template&id=1972412a&"
import script from "./NotificationEditor.vue?vue&type=script&lang=js&"
export * from "./NotificationEditor.vue?vue&type=script&lang=js&"
import style0 from "./NotificationEditor.vue?vue&type=style&index=0&id=1972412a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports